import React, { useRef, useState, useEffect } from "react";
import './styles.css'
import Sorter from "./Sorter";
import { useFilter } from "../../lib/varFilter";

const Filters = () => {
    const filterRef = useRef<HTMLInputElement>(null);
    const { filter } = useFilter();
    const { setFilter } = useFilter();
    const today = new Date();
    const year = today.getFullYear();
    let initialStartYear = 1887
    let initialEndYear = year
    if(filter.start_year === undefined) {
    } else {
        initialStartYear = filter.start_year
    }
    if(filter.end_year === undefined) {
    } else {
        initialEndYear = filter.end_year
    }
    const [startYear, setStartYear] = useState<number>(initialStartYear);
    const [endYear, setEndYear] = useState<number>(initialEndYear);

    useEffect(() => {
        const nfilter = {
            start_year: startYear,
        }
        setFilter((prev) => ({ ...prev, ...nfilter}))
        // console.log(startYear)
        // console.log(nfilter)
        // console.log(filter)
    }, [startYear])
    useEffect(() => {
        const nfilter = {
            end_year: endYear,
        }
        setFilter((prev) => ({ ...prev, ...nfilter}))
        // console.log(endYear)
        // console.log(nfilter)
        // console.log(filter)
    }, [endYear])

    return (
        <div className="filter">
        <p>WIP</p>
        <p>Sort Groups
            <ul>
                <li>Newest: <Sorter sorter='id'/></li>
                <li>Artist: <Sorter sorter='artist'/></li>
                <li>Song: <Sorter sorter='song'/></li>
                <li>Album: <Sorter sorter='album'/></li>
                <li>Length: <Sorter sorter='duration'/></li>
                <li>Plays: <Sorter sorter='plays'/></li>
                <li>Arrangements: <Sorter sorter='new_arr'/></li>
            </ul>
        </p>
        <p><span>Year: </span>
            <input type="number" value={filter.start_year} onChange={(e) => {setStartYear(+e.target.value)}} min={1887} max={Math.min(endYear,year)}/>
            <span> - </span>
            <input type="number" value={filter.end_year} onChange={(e) => {setEndYear(+e.target.value)}} min={Math.max(1887,startYear)} max={year}/>
        </p>
        </div>
    );
}

export default Filters